import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=224d2408&scoped=true&"
import script from "./js/article.js?vue&type=script&lang=js&"
export * from "./js/article.js?vue&type=script&lang=js&"
import style0 from "./Article.vue?vue&type=style&index=0&id=224d2408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d2408",
  null
  
)

export default component.exports